import { render, staticRenderFns } from "./topKinozal.vue?vue&type=template&id=113d4ff8&scoped=true&"
import script from "./topKinozal.vue?vue&type=script&lang=js&"
export * from "./topKinozal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d4ff8",
  null
  
)

export default component.exports